module.exports = __webpack_public_path__ + "media/images/posts/budget-jar-667703ad9757a329088eab43f92d921e.jpg";